module.exports = __webpack_public_path__ + "img/backdoor.3d12f9da.png";